module.exports = __webpack_public_path__ + "img/pr-3.f7d24840.png";